/**
 * Created by mykurisu on 2017/7/9.
 */

/**
使用规则
const loadingstatus = {
    ended: false,
    loading: false,
    has_more: true,
    loadMethod: () => {
        console.log(1)
    }
}
 */

import React from 'react'

import {LoadMore} from 'react-weui'

import '../../styles/ClickLoadMore.css'

class ClickLoadMore extends React.Component {

    renderLoadStyle() {
        //外部传入
        const {ended, loading, has_more, loadMethod} = this.props.loadingstatus;
        if (has_more) {
            if (!ended) {
                if (!loading) {
                    return (
                        <div className="weui-padding text-center click-loadmore-container" onClick={loadMethod}>
                            <a className="click-loadmore-text">
                                查看更多
                            </a>
                        </div>
                    )
                } else {
                    return (
                    <div className="weui-padding click-loadmore-container">
                        <LoadMore loading className="click-loadmore-container_loading">正在加载</LoadMore>
                    </div>
                    )
                }
            } else {
                return (
                    <div className="weui-padding click-loadmore-container_nocolor">
                        <LoadMore showLine>没有更多</LoadMore>
                    </div>
                )
            }
        } else {
            return (
                <div className="weui-padding click-loadmore-container_nocolor">
                    {/*<LoadMore showLine></LoadMore>*/}
                </div>
            )
        }
    }

    render() {
        return (
            <div className="click-loadmore">
                {this.renderLoadStyle()}
            </div>
        )
    }
}

export default ClickLoadMore


// WEBPACK FOOTER //
// ./src/components/wk/WKLoadMore.js